import * as React from 'react';
import { Search } from "../Search/Search";
import { safe } from "../../utils";
import { IPageProperties } from "../../models";

const styles = require('./styles.pcss');
const searchBarStyles = require('./overrides/mainSearch.pcss');

export class PageSearch extends React.Component<IPageProperties, {}>{

    constructor(props) {
        super(props);

    }
    render() {
        let {isLoading, filterOptions, changeFilter, filter, appParams, typeahead } = this.props;

        return (
            <div className={styles.wrapper}>
                <Search
                    isLoading={isLoading}
                    filterOptions={filterOptions}
                    changeFilter={changeFilter}
                    appParams={appParams}
                    filter={filter}
                    typeahead={typeahead}
                    isFundPage={true}
                    styles={searchBarStyles} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/PageSearch/index.tsx